// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qKtPW","crumb":"styles_crumb__U6ias","label":"styles_label__S8lWN","icon":"styles_icon__Nhaew"};